import React from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function BarchartTypeTasks({ data }) {
  const chartData = {
    labels: Object.keys(data),
    datasets: [
      {
        label: "Cantidad de Tareas",
        data: Object.values(data),
        backgroundColor: "rgba(54, 162, 235, 0.6)",
        borderColor: "rgba(54, 162, 235, 1)",
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Distribución de Tareas",
      },
    },
  };

  return (
    <>
    <div className="d-none d-md-block" style={{ width: "700px", height: "350px" }}>
      <Bar data={chartData} options={options} />
    </div>
    <div className="d-block d-md-none" style={{ width: "350px", height: "250px" }}>
      <Bar data={chartData} options={options} />
    </div>
    </>
  );
}

export default BarchartTypeTasks;
